import { render } from "./StoreTabEmployee.vue?vue&type=template&id=37f77c21&scoped=true&ts=true"
import script from "./StoreTabEmployee.vue?vue&type=script&lang=ts"
export * from "./StoreTabEmployee.vue?vue&type=script&lang=ts"

import "./StoreTabEmployee.vue?vue&type=style&index=0&id=37f77c21&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37f77c21"]])

export default __exports__